/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

jQuery(document).ready(function($) {

	var stickyHeaderWidth = 1200,
		stickyHeaderStart = 200,
		headerOffset      = 80;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$('#header-a #main-menu, #header-b #main-menu, #header-d #main-menu').argonmenu({

		resizeWidth: '767',
		collapserTitle: '',
		animSpeed: 'medium',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;'

	});

	$('#main-menu a[href="#"]').click(function(){

		return false;

	});

	$('#header-c .nav-icon').click(function(){

		$('body').toggleClass('nav-open');

	});

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $('#header-a, #header-b, #header-c, #header-d');

	function rpjcStickyHeader() {

		var screenSize = $(window).width(),
			scrollTop  = $(document).scrollTop(),
			wrapper    = $('#wrapper');

		if (screenSize < stickyHeaderWidth ) return;

		if ( scrollTop > stickyHeaderStart ) {

			$(stickyHeader).addClass('stuck');
			$(wrapper).addClass('header-stuck');

		} else {

			$(stickyHeader).removeClass('stuck');
			$(wrapper).removeClass('header-stuck');

		}

	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$('.toggle-search').click(function() {

		$('body').toggleClass('search-open');

		$('.site-search input[type="text"]').focus();

		return false;

	});

	$('.site-search-close').click(function() {

		$('body').toggleClass('search-open');

		return false;

	});

	//--------------------------------------------
	// Carousels
	//--------------------------------------------

	$('#slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: true

	});

	var $container = $('.center-scroller');

	$container.imagesLoaded(function(){

		$container.slick({
			centerMode: true,
			centerPadding: 0,
			slidesToShow: 3,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
			nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$container.show();

	});


	//
	// $('.center-scroller').slick({
	// 	centerMode: true,
	//   // centerPadding: '60px',
	//   slidesToShow: 1,
	// 	autoplay: true,
	// 	autoplaySpeed: 5000,
	// 	arrows: true,
	// 	prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
	// 	nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
	// 	dots: true
	//
	// });


	$('#landing .slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		fade: true,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: false,
		pauseOnFocus: false,
		pauseOnHover: false

	});

	$('.section-testimonials .slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: true,
		fade: true

	});

	$('.logo-scroller .slider').slick({
		dots: false,
		arrows: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		speed: 1000,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.section-slides').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: false

	});

	$('.slider-gallery .slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.slider-nav'
	});

	$('.slider-gallery .slider-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.slider-for',
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		centerMode: false,
		focusOnSelect: true
	});

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$('.lightbox-image').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-iframe').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'iframe'
	});

	$('.lightbox-team').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific rpjc-magnific-team',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'ajax',
		fixedContentPos: true
	});

	$('.gallery-item').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image',
		gallery: {
			enabled: true,
			arrowMarkup: '<div title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span></span><span></span></div>'
		}
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$('.accordion .accordion-content').hide();

	var hash = window.location.hash;

	// check if there's hash tag in the URL
	if (hash.length) {

		var selectedAccordionItem = $('body').find('.accordion .accordion-item' + hash);

		// if yes, open the matching accordion item
		if (selectedAccordionItem.length) {

			selectedAccordionItem.addClass('selected').find('.accordion-content').show();

			// perform scroll down but add in 140 padding for the sticky header
			$('html, body').animate({scrollTop: selectedAccordionItem.offset().top - 140},'slow');

		}

	}

	$('.accordion-handle').click(function(){

		var accordion = $(this).parent().parent();

		if ($('.accordion-content').not(':animated')) {

			if ($(this).parent().hasClass('selected')) {

				$(this).next().slideUp(300).end().parent().removeClass('selected');

			} else {

				$(accordion).find('.accordion-item').removeClass('selected');
				$(this).parent().addClass('selected');
				$(accordion).find('.accordion-content').slideUp(300);
				$(this).next().slideDown(300);

			}

		}

		return false;

	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$('.tabbed-content .tab-nav li:first-child').addClass('active');
	$('.tabbed-content .tab-window .tab-panel').not(':first-child').hide();

	$('.tabbed-content .tab-nav a').click(function(){

		var target = $(this).attr('href');

		$(this).parent().addClass('active').siblings().removeClass('active');

		$(target).show().siblings().hide();

		return false;

	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$('.scroll-to').click(function(){

		var selected = $(this).attr('href'),
			scrollPx = ($(window).width() < stickyHeaderWidth) ? $(selected).offset().top - 20 : $(selected).offset().top - headerOffset;

		$('html, body').animate({scrollTop: scrollPx},'slow');

		return false;

	});

	// Scroll to top link

	$('a[href="#top"]').click(function(){

		$('html, body').animate({scrollTop:0}, 'slow');

		return false;

	});

	$('.scroll-down, .scrolldown').click(function(){

		var target = $(this).parent().next(),
			distance;

		if ($(window).width() < 960) {

			distance = $(target).offset().top - 60;

		} else {

			distance = $(target).offset().top - 105;

		}

		$('html, body').animate({scrollTop: distance},'slow');

		return false;

	});

    //--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$( '.responsive-scroll' ).each( function() {

		var element       = $( this ),
			scrollWrapper = $( '<div />', {

				'class' : 'scrollable',
				'html'  : '<div class="scrollable-inner" />'

			} ).insertBefore( element );

		element.data( 'scrollWrapper', scrollWrapper );
		element.appendTo( scrollWrapper.find( 'div' ) );

		if ( element.outerWidth() > element.parent().outerWidth() ) {

			element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

		}

		$( window ).on( 'resize orientationchange', function() {

			if ( element.outerWidth() > element.parent().outerWidth() ) {

				element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

			} else {

				element.data( 'scrollWrapper' ).removeClass( 'has-scroll' );

			}

		} );

	} );

	//--------------------------------------------
	// Add placeholder support for older browsers
	//--------------------------------------------

	if(!Modernizr.input.placeholder){

		$('[placeholder]').focus(function() {

			var input = $(this);

			if (input.val() === input.attr('placeholder')) {
				input.val('');
				input.removeClass('placeholder');
			}

		}).blur(function() {

			var input = $(this);

			if (input.val() === '' || input.val() === input.attr('placeholder')) {

				input.addClass('placeholder');
				input.val(input.attr('placeholder'));

			}

		}).blur();

		$('[placeholder]').parents('form').submit(function() {

			$(this).find('[placeholder]').each(function() {

				var input = $(this);

				if (input.val() === input.attr('placeholder')) {

					input.val('');

				}

			});

		});

	}

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$('.main').fitVids();

});
